import styled from "styled-components";

export const TitleTopCupons = styled.h2`
    text-align: center;
    margin: 40px 0 10px 0;
    color: #348AC7;
    font-weight: 900;
    font-family: "Lato", sans-serif;
    width: 100%;
    font-size: 30px;

    @media (max-width: 768px) {
        font-size: 28px;
        margin-bottom: 20px;
    }
`;

export const TopCouponList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center;
    width: 100%;
    max-width: 950px;
    margin: 20px auto 0 auto;
    gap: 20px;
    padding: 0 16px;

    @media (max-width: 768px) {
        gap: 16px;
        padding: 0;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 24px;
`;

export const Button = styled.button`
    padding: 12px 24px;
    font-size: 16px;
    font-weight: bold;
    background-color: transparent;
    color: #4196CB;
    border: 1px solid #4196CB;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
        background-color: #4196CB;
        color: #ffffff;
    }
`;

export const Divider = styled.hr`
    width: 100%;
    max-width: 300px;
    height: 2px;
    border: none;
    background-color: #d3d3d3; 
    margin: 40px auto 16px auto;
    opacity: 0.8;

    @media (max-width: 768px) {
        max-width: 70%;
        margin: 38px auto 12px auto;
    }
`;